import {
  renderSelectCompany,
  renderEmptyDataAlertWindow,
  renderSelectedCompanyTable,
} from "./controllerPlan.js";

import {
  companyRowsValid,
  planRowsValid,
  cropRowsValid,
  companyRows,
  planRows,
  cropRows,
} from "./controller.js";

import { renderPlanRecap } from "./helperPlan.js";

//Variables
let originalCompanyRows,
  originalPlanRows,
  originalCropRows,
  openPlanWindow,
  account;
let selectedCompanyPlan = new Object();

export const controlOpenPlanProject = async function (
  openPlanWindowReal,
  currBtn,
  currentAccount
) {
  console.log("control open plan project");

  console.log("currentAccount xxx", currentAccount);
  //Variables
  openPlanWindow = openPlanWindowReal;
  console.log(openPlanWindow);
  account = currentAccount;

  //Update OriginalXRows
  originalCompanyRows = await companyRowsValid(companyRows);
  originalPlanRows = await planRowsValid(planRows);
  originalCropRows = await cropRowsValid(cropRows);

  console.log(originalPlanRows);
  /*
  const markup = `Selezionare Azienda e Piano per visualizzare il Piano scelto.`;
  openPlanWindow.insertAdjacentHTML("afterbegin", markup);*/

  const selectCompanyPlanMarkup = `
  <br>
  
    <div class="upload__column-select-plan">
        </div> 
        <div class="select-company">
        </div>
        <div class="select-plan">
        </div>
    
    <button class="btn company-plan__btn">
    <span>Visualizza Piano</span>
    </button>
    `;

  /* const selectCompanyPlanMarkup = `
  <br>
  <form class="upload select-company-plan">
    <div class="upload__column-select-plan">
        </div> 
        <div class="select-company">
        </div>
        <div class="select-plan">
        </div>
    </form>
    <button class="btn company-plan__btn">
    <span>Visualizza Piano</span>
    </button>
    `;*/

  openPlanWindow.insertAdjacentHTML("beforeend", selectCompanyPlanMarkup);

  //Form Elements
  //const form = document.querySelector(".select-company-plan");
  const selectCompanyForm = document.querySelector(".select-company");
  const selectPlanForm = document.querySelector(".select-plan");
  const companyPlanBtn = document.querySelector(".company-plan__btn");

  const selectCompany = await renderSelectCompany(selectCompanyForm);

  checkSelectedCompany(
    selectCompany,
    selectCompanyForm,
    selectPlanForm,
    companyPlanBtn
  );

  checkCompanyPlanBtn(companyPlanBtn);
};

const checkSelectedCompany = function (
  selectCompany,
  selectCompanyForm,
  selectPlanForm,
  companyPlanBtn
) {
  selectCompany.addEventListener("change", function (e) {
    const selectedOption = e.target.options[e.target.selectedIndex];
    const currCompanyId = selectedOption.dataset.companyId;
    console.log("Selected company ID:", currCompanyId);

    const selectedCompanyRowArray = originalCompanyRows.filter(
      (r) => r.companyId === currCompanyId
    );

    renderSelectedCompanyTable(selectedCompanyRowArray, selectCompanyForm);

    selectedCompanyPlan.company = currCompanyId;
    console.log("Selected company plan:", selectedCompanyPlan);

    const selectedCompanyPlans = originalPlanRows.filter(
      (plan) => plan.companyId === currCompanyId
    );
    console.log("Company plans:", selectedCompanyPlans);

    if (selectedCompanyPlans.length === 0) {
      console.log("L azienda selezionata non ha alcun piano");
      renderEmptyDataAlertWindow(
        "L'azienda selezionata non ha alcun piano.",
        openPlanWindow,
        "openPlan"
      );
      selectPlanForm.innerHTML = "";
    } else {
      console.log("Esiste almeno 1 piano per l azienda selezionata");
      renderSelectPlans(selectPlanForm, selectedCompanyPlans, companyPlanBtn);
    }
  });
};

const renderSelectPlans = function (
  selectPlanForm,
  selectedCompanyPlans,
  companyPlanBtn
) {
  console.log("render select plans");

  selectPlanForm.innerHTML = "";

  const markup = `
  <br>
  <div class="new-plan-div new-plan-div-open">
  <img src="/icons/menu-openPlan.jpg" alt="openPlan" class="menu__btn-icon">
  <h3> SELEZIONARE PIANO</h3>
  </div>
  <select id="plan-select" >
    <option value=""> --Seleziona piano--</option>
  </select>
  <br>`;

  selectPlanForm.insertAdjacentHTML("beforeend", markup);

  const selectPlan = document.getElementById("plan-select");

  createPlanOptions(selectPlan, selectedCompanyPlans);

  checkSelectedPlan(selectPlanForm, companyPlanBtn);
};

const createPlanOptions = function (selectPlan, selectedCompanyPlans) {
  console.log(selectedCompanyPlans);

  const options = selectedCompanyPlans.map((plan) => ({
    id: plan.planId,
    text: `${plan.planName} - ${plan.date}`,
  }));

  //Render company options
  options.forEach((option) => {
    let element = document.createElement("option");
    element.textContent = option.text;
    element.value = option.text;
    element.dataset.planId = option.id;
    selectPlan.appendChild(element);
  });
};

const checkSelectedPlan = function (selectPlanForm, companyPlanBtn) {
  console.log("check selected plan");

  selectPlanForm.addEventListener("change", async function (e) {
    e.preventDefault();
    //const selectedPlanId = e.target.value;
    console.log("e.target", e.target);
    const selectedOption = e.target.options[e.target.selectedIndex];
    const selectedPlanId = selectedOption.dataset.planId;

    console.log("selectedPlanId xxxxxx", selectedPlanId);
    if (selectedPlanId) {
      console.log("selectedPlanId", selectedPlanId);

      selectedCompanyPlan.plan = selectedPlanId;
      const selectedPlan = originalPlanRows.find(
        (plan) => plan.planId === selectedPlanId
      );

      const openPlanBtn = document.querySelector("company-plan__btn");
      console.log("OpenPlanBtn: ", openPlanBtn);

      openPlanBtn.addEventListener("click", async function () {
        console.log("open plan btn clicked");
        if (selectedPlan) {
          openPlanWindow.innerHTML = "";
          await renderPlanRecap(selectedPlan.planId, openPlanWindow, account);
          const openPlanNav = document.querySelector(".open-plan-nav");
          openPlanNav.classList.remove("no-pointer-events");
        }
      });
    }
  });
};

const checkCompanyPlanBtn = function (companyPlanBtn) {
  console.log("check btn");

  console.log(selectedCompanyPlan);

  companyPlanBtn.addEventListener("click", async function () {
    console.log(`company plan btn clicked`);

    console.log("selectedCompanyPlan", selectedCompanyPlan);
    if (selectedCompanyPlan.company && selectedCompanyPlan.plan) {
      openPlanWindow.innerHTML = "";
      await renderPlanRecap(selectedCompanyPlan.plan, openPlanWindow, account);
      const openPlanNav = document.querySelector(".open-plan-nav");
    } else {
      console.log("company plan non selezionati");
    }
  });
};

const controlUpdatePlan = function (currPlanId, openPlanNav) {
  const markupUpdatePlan = `<button class="btn update-plan_btn">
      <span>Modifica Piano</span>
    </button>`;
  openPlanNav.insertAdjacentHTML("beforeend", markupUpdatePlan);

  const updatePlanBtn = document.querySelector(".update-plan_btn");

  updatePlanBtn.addEventListener("click", function () {
    console.log(`update plan ${currPlanId}`);
  });
};
